import { useCookieState } from 'ahooks'

import { COOKIES } from '@/utils/http'

type MediaType = 'application/json' | 'text/plain' | 'text/csv'
export function useHttpDefaultApiHeaders(
  contentType: MediaType = 'application/json',
  acceptMediaType: MediaType = 'application/json'
) {
  const [token] = useCookieState(COOKIES.XSRF_TOKEN)

  const headers = new Headers({
    Accept: acceptMediaType,
    'Content-Type': contentType,
    'X-XSRF-TOKEN': token,
  })
  return { headers, token }
}
